export default Object.freeze({
  ELEMENT_UI_MSG_DURATION: 3000, // element-ui message组件默认自动关闭时间
})


// WEBPACK FOOTER //
// ./src/consts/index.js